import { z } from 'zod'

import {
  classAbsencePresence,
  classAbsenceStatus,
  columnsSchema,
  paginationSchema
} from '@/utils/zod'

export const classesAbsencesFilterSchema = z.object({
  semester: z.string(),
  courseId: z.array(z.string()).optional(),
  studentId: z.array(z.string()).optional(),
  dateAfter: z.string().optional(),
  dateBefore: z.string().optional(),
  status: z.array(classAbsenceStatus).optional(),
  presence: classAbsencePresence,
  ...paginationSchema.shape,
  ...columnsSchema.shape
})

export type AbsencesFiltersKeys = keyof z.infer<
  typeof classesAbsencesFilterSchema
>
